import React, { useContext, useEffect, useState } from "react";
import ModalFull from "./ModalFull";
import { MainContext } from "../../contexts/MainContext";
import DateFormat from "../DateFormat";
import ApiDeleteX2 from "../ApiServicesX/ApiDeleteX2";
import ApiGetX2 from "../ApiServicesX/ApiGetX2";
import { AiFillCloseSquare } from "react-icons/ai";
import { RiEditBoxFill } from "react-icons/ri";
import { useNavigate, useRoutes } from "react-router-dom";
import { IoIosMore } from "react-icons/io";
import { CiSquareMore } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import { AiOutlineCloseSquare } from "react-icons/ai";
import { Api } from "@mui/icons-material";

export default function MyZayecheh({ state }) {
  let { setAllUserShaps, allUserShaps, allQuestions, titleTopics, userId, ismyZayeheh, setIsMyZayeheh, setQuestionIdCon, setTitleIdCon, setLotNameCon, allShaps, setAllShaps, setResult, setUserShapId } =
    useContext(MainContext);
  const navigat = useNavigate();
  const [state2, setState2] = useState(true);

  const deletUserShape = (id) => {
    const url = `/api/AgMain/deleteUseShape?UShapId=${id}`;
    const url2 = `/api/AgMain/getUserShapeByUserID?userId=${userId}`;
    ApiDeleteX2(url, function () {
      ApiGetX2(url2, setAllUserShaps); ////<== گرفتن مجدد شکلهای کاربر بعد از انجام عمل حذف
    });
  };

  const clickAction = (id, qId, tiId, LotN, result) => {
    setQuestionIdCon("");
    setTitleIdCon("");
    setLotNameCon("");
    setAllShaps([]);
    ApiGetX2(`/api/AgMain/getUserShapeById?UShapId=${id}`, setAllShaps);
    setIsMyZayeheh(true);
    setQuestionIdCon(qId);
    setTitleIdCon(tiId);
    setLotNameCon(LotN);
    setResult(result);
    setUserShapId(id);
    navigat("/ramlpic");
    setState2(false);
    setInterval(() => {
      setState2(true);
    }, 0.5);
  };

  useEffect(() => {
    const url2 = `/api/AgMain/getUserShapeByUserID?userId=${userId}`;
    ApiGetX2(url2, setAllUserShaps);
  },
    [allShaps]
    // [allUserShaps]
  );

  useEffect(() => {
    setIsMyZayeheh(false);
    // setAllShaps([]);
  }, [ismyZayeheh]);
  return (
    <ModalFull breakpoint={true} text={"انتخاب زاییچه های ذخیره شده"} state={state} state2={state2}>
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <table className="table table-striped select-userShape-table boxSh">
              <thead>
                <tr key="showUserShape">
                  <th>ردیف</th>
                  <th> نام زایچه /تاریخ ایجاد </th>
                  <th>موضوع</th>
                  <th>سوال</th>
                  <th>نمایش /حذف</th>
                </tr>
              </thead>

              <tbody>
                {allUserShaps?.length != 0 &&
                  allUserShaps?.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {item.lotName} <br />
                        <DateFormat dateString={item.createDate} />
                      </td>
                      <td>{titleTopics?.filter((filter) => filter.id == item.titleID)[0]?.description} </td>
                      <td>{allQuestions?.filter((filter) => filter.id == item.agQuestionId)[0]?.description}</td>
                      <td>
                        <button
                          className="btn btn-info rvhide select-editbut"
                          onClick={() => {
                            clickAction(item.id, item.agQuestionId, item.titleID, item.lotName, item.result);
                          }}
                        >
                          <IoIosMore style={{ color: "#fff" }} />
                        </button>

                        <span
                          className="rvshow"
                          onClick={() => {
                            clickAction(item.id, item.agQuestionId, item.titleID, item.lotName, item.result);
                          }}
                        >
                          <CiSquareMore style={{ color: "green", fontSize: "20px" }} />
                        </span>

                        <button className="btn btn-danger rvhide select-delebut" onClick={() => deletUserShape(item.id)}>
                          <IoClose />
                        </button>

                        <span className="rvshow" style={{ cursor: "pointer" }} onClick={() => deletUserShape(item.id)}>
                          {" "}
                          <AiOutlineCloseSquare style={{ color: "red", fontSize: "20px" }} />
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ModalFull>
  );
}
